import { CommonModule } from '@angular/common';
import { Component, computed, input, Input } from '@angular/core';
import { colors } from '../../../theme-preset';

import { EChartsOption } from 'echarts';
import { NgxEchartsDirective } from 'ngx-echarts';

export interface MixedChartData {
  category: string;
  valueBar: number;
  valueLine: number;
}

@Component({
  selector: 'app-mixed-chart-card',
  standalone: true,
  imports: [CommonModule, NgxEchartsDirective],
  templateUrl: './mixed-chart-card.component.html',
  styleUrl: './mixed-chart-card.component.scss',
})
export class MixedChartCardComponent {
  @Input() titleText = '';
  data = input<MixedChartData[] | undefined>(undefined);
  @Input() precision = 0;
  barAxis = input.required<{
    name: string;
    axisLabel?: { formatter: string };
  }>();
  lineAxis = input.required<{
    name: string;
    axisLabel?: { formatter: string };
  }>();

  chartOptions = computed<EChartsOption | null>(() => {
    const data = this.data();
    if (data) {
      const options: EChartsOption = {
        color: colors.palette,
        title: { show: false },
        grid: { left: '0%', right: '0%' },
        legend: {
          orient: 'horizontal',
          right: 'center',
          bottom: 20,
        },
        xAxis: {
          type: 'category',
          data: this.data()?.map((x) => x.category) ?? [],
        },
        yAxis: [
          { type: 'value', ...this.barAxis() },
          { type: 'value', ...this.lineAxis(), alignTicks: true },
        ],
        series: [
          {
            type: 'bar',
            name: this.barAxis().name,
            data: this.data()?.map((x) => x.valueBar) ?? [],
          },
          {
            type: 'line',
            yAxisIndex: 1,
            name: this.lineAxis().name,
            data: this.data()?.map((x) => x.valueLine) ?? [],
          },
        ],
        tooltip: { show: true },
      };
      return options;
    }
    return null;
  });

  customizeTooltip = (arg: any) => {
    return {
      text: `${arg.argumentText}: ${arg.valueText}`,
    };
  };
}
